import { create } from "zustand";
import { supabase } from "../lib/supabase";

// Shared wishlist state synced with Supabase `wishlist` table. Matches the
// mobile app's semantics so hearts stay consistent across platforms.
export const useWishlist = create((set, get) => ({
  map: {},
  loaded: false,

  load: async () => {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user) {
      set({ map: {}, loaded: true });
      return;
    }
    const { data } = await supabase
      .from("wishlist")
      .select("product_id")
      .eq("user_id", session.user.id);
    const map = {};
    (data || []).forEach((r) => {
      map[r.product_id] = true;
    });
    set({ map, loaded: true });
  },

  toggle: async (productId) => {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user) return null;
    const userId = session.user.id;
    const was = !!get().map[productId];

    const next = { ...get().map };
    if (was) delete next[productId];
    else next[productId] = true;
    set({ map: next });

    if (was) {
      await supabase.from("wishlist").delete().eq("user_id", userId).eq("product_id", productId);
    } else {
      const { error } = await supabase.from("wishlist").insert({ user_id: userId, product_id: productId });
      if (error) {
        const reverted = { ...get().map };
        delete reverted[productId];
        set({ map: reverted });
        return false;
      }
    }
    return !was;
  },

  isWished: (productId) => !!get().map[productId],

  clear: () => set({ map: {}, loaded: false }),
}));
